import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useDialog from '../../../../hooks/useDialog';
import ProposalForm from './ProposalForm';

export function DialogSale({ mutate }) {
    const navigate = useNavigate();
    const { open, id } = useDialog('#contrato');

    useEffect(() => {
        if (open && id) {
            navigate(`/dashboard/propostas/${id}`, { replace: true });
        }
    }, [open, id, navigate]);

    if (open && !id) return <ProposalForm mutate={mutate} />;
    return null;
}
